import moment from 'moment';
import { getIn18Text } from 'api';
export const getScacles = ({ startHour, endHour, pieceOfHour, date }) => {
    const scales = new Array((endHour - startHour) * pieceOfHour).fill(null).map((_, index) => {
        const scale = moment(date)
            .startOf('minutes')
            .hour(Math.floor(index / pieceOfHour) + startHour)
            .minutes((index % pieceOfHour) * (60 / pieceOfHour));
        const startTime = scale;
        const endTime = scale.clone().add(1 / pieceOfHour, 'hours');
        return [startTime, endTime];
    });
    return scales;
};
export const fixedDateTimeRange = (ranges) => ranges === null || ranges === void 0 ? void 0 : ranges.map(e => e.map(d => d.set({ second: 0, milliseconds: 0 })));
export const calculateWidth = (range, scales, width, startHour, pieceOfHour) => {
    const [rangeStart, rangeEnd] = range;
    const scaleStart = scales[0][0];
    const scaleEnd = scales[scales.length - 1][1];
    const interactRange = rangeInteract(range, [scaleStart, scaleEnd]);
    if (interactRange) {
        const [start, end] = interactRange;
        const startOverflow = scaleStart.isAfter(rangeStart);
        const endOverflow = scaleEnd.isBefore(rangeEnd);
        const duration = end.diff(start, 'hours', true);
        const elementLeft = (start.hours() * pieceOfHour + start.minutes() / (60 / pieceOfHour) - startHour * pieceOfHour) * (width / scales.length);
        const elementWidth = duration * (width / scales.length) * pieceOfHour;
        return {
            elementLeft,
            elementWidth,
            startOverflow,
            endOverflow,
        };
    }
    return {
        elementLeft: 0,
        elementWidth: 0,
    };
};
export const isRangeInteract = (range, ranges) => ranges === null || ranges === void 0 ? void 0 : ranges.reduce((prev, curRnage) => {
    const [ocStart, ocEnd] = curRnage;
    return prev || ocStart.isBetween(range[0], range[1]) || (ocStart.isBefore(range[0]) && ocEnd.isAfter(range[0]));
}, false);
export const rangeInteract = (range1, range2) => {
    const [start1, end1] = range1;
    const [start2, end2] = range2;
    const start = start1.isBefore(start2) ? start2 : start1;
    const end = end1.isAfter(end2) ? end2 : end1;
    if (start.isBefore(end)) {
        return [start, end];
    }
    else {
        return null;
    }
};
export const getDefaultForbidden = (pieceOfHour) => [
    moment().startOf('day'),
    moment()
        .startOf('hour')
        .minute(Math.ceil(moment().minutes() / (60 / pieceOfHour)) * (60 / pieceOfHour)),
];
export const getDurationText = (range) => {
    const [start, end] = range;
    const formatter = `${moment().year() === start.year() ? '' : getIn18Text('YYYYNIAN@')}M月D日（星期dd）HH:mm`;
    return start.format(formatter) + '-' + end.format('HH:mm');
};
